import { PriceProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface IPriceProps {
  id?: string
  name: string | null
  fee: number | null
  share: number | null
  max: number | null
  isGroup: boolean | null
  order: number | null
  properties?: PriceProperties | null
  createdAt: string | null
  updatedAt: string | null
}

export default class PriceEntity {
  private _props: IPriceProps

  constructor(props?: IPriceProps | null) {
    this._props = EmptyPricePropsFactory(props)
  }

  get props(): IPriceProps {
    return this._props
  }

  get clone(): IPriceProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get name(): string | null {
    return this._props.name
  }

  get fee(): number | null {
    return this._props.fee
  }

  get share(): number | null {
    return this._props.share
  }

  get max(): number | null {
    return this._props.max
  }

  get isGroup(): boolean | null {
    return this._props.isGroup
  }

  get order(): number | null {
    return this._props.order
  }

  get properties(): PriceProperties | null | undefined {
    return this._props.properties
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyPricePropsFactory = (props?: Partial<IPriceProps> | null): IPriceProps => ({
  name: null,
  fee: null,
  share: null,
  max: null,
  isGroup: null,
  order: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
